import React, { useContext } from 'react'
import './style.scss'
import NaviContext from '../../../../context/NaviContext'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
//import { Transition, TransitionGroup } from 'react-transition-group'
//import anime from 'animejs'

import { Link } from 'gatsby'

function NaviItem(props) {
	const naviContext = useContext(NaviContext)

	const id = props.id
	const label = props.label
	const description = props.description

	// disabled flag
	let enabled = true
	const classes = props.cssClasses.map((cssClass) => {
		// if one of the classes is disabled, set the flag
		if (cssClass === 'disabled') {
			enabled = false
		}
		// if it has description, add the hint classes
		if (description) {
			return cssClass + ' hint--rounded hint--bottom'
		} else {
			return cssClass
		}
	}).join(' ')

	const target = props.target
	const path = props.path
  const url = props.url
	const parentId = props.parentId
	const internal = props.connectedNode
	const dropDownClickHandle = props.dropDownClickHandle

	if ( internal ) {
		return (
			<div
				key={id}
				className={`nav-item ${classes} ${props.isOpen ? 'active' : ""} ${parentId ? 'sub' : 'parent'}`}
				data-hint={description}
			>
				{enabled ?
          <div className="wrapper">
            <Link
            	to={path}
              onClick={() => { naviContext.setHamburgerActive(false); naviContext.setActive(false); }}
              onKeyDown={() => { naviContext.setHamburgerActive(false); naviContext.setActive(false); }}
              // onMouseEnter={ props.itHasChildren && !naviContext.windowSize.mobile ? dropDownClickHandle : null }
              className="linking-int"
            >
              {label}
            </Link>
            {props.itHasChildren ? <FontAwesomeIcon onClick={props.itHasChildren ? dropDownClickHandle : null} icon={faAngleDown} className={`caret  ${props.isOpen ? 'open' : ""}`} /> : null}
          </div>  
				:
					<div className="disabled">
						{label}
						{props.itHasChildren ? <FontAwesomeIcon icon={faAngleDown} className="caret" /> : null}
					</div>
				}
				{props.children}
			</div>
		)
	}

	return (
		<div
			key={id}
			className={`nav-item ${classes} ${props.isOpen ? 'active' : ""} ${parentId ? 'sub' : 'parent'}`}
			data-hint={description}
		>
			{enabled ?
      <div className='wrapper'>
				<a 
					href={url}
					target={target}
					rel={target === '_blank' ? 'noopener noreferrer' : null}
          onClick={() => { naviContext.setHamburgerActive(false); naviContext.setActive(false); }}
          onKeyDown={() => { naviContext.setHamburgerActive(false); naviContext.setActive(false); }}
          // onMouseEnter={ props.itHasChildren && !naviContext.windowSize.mobile ? dropDownClickHandle : null }
          className="linking-int"
				>
					{label}
				</a>
        {props.itHasChildren ? <FontAwesomeIcon aria-label='Open Drop Down Menu' onClick={props.itHasChildren ? dropDownClickHandle : null} icon={faAngleDown} className={`caret  ${props.isOpen ? 'open' : ""}`} /> : null}
      </div>
			:
				<div className="disabled">
					{label}
					{props.itHasChildren ? <FontAwesomeIcon icon={faAngleDown} className="caret" /> : null}
				</div>
			}
			{props.children}
		</div>
	)
}

export default NaviItem